<template>
  <span class="ais-Highlight ml-3" v-html="innerHtml" @click="click"></span>
</template>

<script>
/* eslint-disable */

function getPropertyByPath(object, path) {
  const parts = path.split('.');

  return parts.reduce((current, key) => current && current[key], object);
}

const htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

const regexUnescapedHtml = /[&<>"']/g;

// make sure escape can be done only once, by doing it per hihglight component
function escapeHtml(html) {
  return html.replace(regexUnescapedHtml, character => htmlEscapes[character])
}

export default {
  props: {
    hit: {
      type: Object,
      required: true,
    },
    attribute: {
      type: String,
      required: true,
    },

  },
  methods: {
    click() {
      this.$emit('click');
    }
  },
  computed: {
    innerHtml() {
      const highlight = getPropertyByPath(this.hit._highlightResult, this.attribute)
      //console.log(`hightlight.value=${highlight.value}`);
      //return escapeHtml(highlight.value)              
        //.replace(/__highlight__/g, '<mark class=\"ais-Highlight-highlighted\">')
        //.replace(/__\/highlight__/g, '</mark>') 
        return highlight.value       
            .replace(/<em>/g, '<mark class="ais-Highlight-highlighted">')
            .replace(/<\/em>/g, '</mark>')

    }
  }
}
</script>
